import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export default function useRolePermissions() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useListByRole(roleId: string) {
        return useQuery({
            queryKey: ["role-permissions", roleId],
            queryFn: async () => {
                const response = await axiosPrivate.get(`/v1/role-permissions/${roleId}`);
                return parseSuccessResponseData(response);
            },
            enabled: !!roleId,
        });
    }

    function useAssign() {
        return useMutation({
            mutationFn: (parameters: { RoleId: string; PermissionIds: string[] }) =>
                axiosPrivate.post(`/v1/role-permissions/assign`, parameters).then(parseSuccessResponseData),
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries({ queryKey: ["role-permissions", variables.RoleId] });
            },
        });
    }

    return { useListByRole, useAssign };
}
